
const tenantActions = {
  DO_INVITE_TENANT: 'DO_INVITE_TENANT',
  DO_INVITE_TENANT_SUCCEEDED: 'DO_INVITE_TENANT_SUCCEEDED',
  DO_INVITE_TENANT_FAILED: 'DO_INVITE_TENANT_FAILED',
  DO_INVITE_TENANT_RESET: 'DO_INVITE_TENANT_RESET',

  DO_ADD_CURRENT_TENANT: 'DO_ADD_CURRENT_TENANT',
  DO_ADD_CURRENT_TENANT_SUCCEEDED: 'DO_ADD_CURRENT_TENANT_SUCCEEDED',
  DO_ADD_CURRENT_TENANT_FAILED: 'DO_ADD_CURRENT_TENANT_FAILED',
  DO_ADD_CURRENT_TENANT_RESET: 'DO_ADD_CURRENT_TENANT_RESET',

  DO_LIST_CURRENT_TENANTS: 'DO_LIST_CURRENT_TENANTS',
  DO_LIST_CURRENT_TENANTS_SCCEEDED: 'DO_LIST_CURRENT_TENANTS_SCCEEDED',
  DO_LIST_CURRENT_TENANTS_FAILED: 'DO_LIST_CURRENT_TENANTS_FAILED',

  DO_LIST_REFERENCE_TENANTS: 'DO_LIST_REFERENCE_TENANTS',
  DO_LIST_REFERENCE_TENANTS_SCCEEDED: 'DO_LIST_REFERENCE_TENANTS_SCCEEDED',
  DO_LIST_REFERENCE_TENANTS_FAILED: 'DO_LIST_REFERENCE_TENANTS_FAILED',

  DO_SHOW_NEW_REFERENCE_FORM: 'DO_SHOW_NEW_REFERENCE_FORM',
  DO_HIDE_NEW_REFERENCE_FORM: 'DO_HIDE_NEW_REFERENCE_FORM',

  DO_SHOW_NEW_CURRENT_FORM: 'DO_SHOW_NEW_CURRENT_FORM',
  DO_HIDE_NEW_CURRENT_FORM: 'DO_HIDE_NEW_CURRENT_FORM',
  
  DO_GET_TENANT_REQUEST_REFERENCE: 'DO_GET_TENANT_REQUEST_REFERENCE',
  DO_GET_TENANT_REQUEST_REFERENCE_SUCCEEDED: 'DO_GET_TENANT_REQUEST_REFERENCE_SUCCEEDED',
  DO_GET_TENANT_REQUEST_REFERENCE_FAILED: 'DO_GET_TENANT_REQUEST_REFERENCE_FAILED',
  
  DO_UPDATE_TENANT_REQUEST_REFERENCE: 'DO_UPDATE_TENANT_REQUEST_REFERENCE',
  DO_UPDATE_TENANT_REQUEST_REFERENCE_SUCCEEDED: 'DO_UPDATE_TENANT_REQUEST_REFERENCE_SUCCEEDED',
  DO_UPDATE_TENANT_REQUEST_REFERENCE_FAILED: 'DO_UPDATE_TENANT_REQUEST_REFERENCE_FAILED',

  DO_GET_OUTSTANDING_REFERENCE_REQUESTS: 'DO_GET_OUTSTANDING_REFERENCE_REQUESTS',
  DO_GET_OUTSTANDING_REFERENCE_REQUESTS_SUCCESS: 'DO_GET_OUTSTANDING_REFERENCE_REQUESTS_SUCCESS',
  DO_GET_OUTSTANDING_REFERENCE_REQUESTS_FAILED: 'DO_GET_OUTSTANDING_REFERENCE_REQUESTS_FAILED',
  
  DO_GET_TENANT_REFERENCE: 'DO_GET_TENANT_REFERENCE',
  DO_GET_TENANT_REFERENCE_SUCCEEDED: 'DO_GET_TENANT_REFERENCE_SUCCEEDED',
  DO_GET_TENANT_REFERENCE_FAILED: 'DO_GET_TENANT_REFERENCE_FAILED',
  
  DO_GET_RENT_VERIFY_DETAILS: 'DO_GET_RENT_VERIFY_DETAILS',
  DO_GET_RENT_VERIFY_DETAILS_SUCCESS: 'DO_GET_RENT_VERIFY_DETAILS_SUCCESS',
  DO_GET_RENT_VERIFY_DETAILS_FAILED: 'DO_GET_RENT_VERIFY_DETAILS_FAILED',

  DO_VERIFY_PAYMENT: 'DO_VERIFY_PAYMENT',
  DO_VERIFY_PAYMENT_SUCCESS: 'DO_VERIFY_PAYMENT_SUCCESS',
  DO_VERIFY_PAYMENT_FAILED: 'DO_VERIFY_PAYMENT_FAILED',

  DO_DECLINE_PAYMENT: 'DO_DECLINE_PAYMENT',
  DO_DECLINE_PAYMENT_SUCCESS: 'DO_DECLINE_PAYMENT_SUCCESS',
  DO_DECLINE_PAYMENT_FAILED: 'DO_DECLINE_PAYMENT_FAILED',

  DO_REMOVE_REFERENCE_TENANT: 'DO_REMOVE_REFERENCE_TENANT',
  DO_REMOVE_REFERENCE_TENANT_RESET: 'DO_REMOVE_REFERENCE_TENANT_RESET',
  DO_REMOVE_REFERENCE_TENANT_FAILED: 'DO_REMOVE_REFERENCE_TENANT_FAILED',

  DO_REMOVE_INVITE_TENANT: 'DO_REMOVE_INVITE_TENANT',
  DO_REMOVE_INVITE_TENANT_RESET: 'DO_REMOVE_INVITE_TENANT_RESET',
  DO_REMOVE_INVITE_TENANT_FAILED: 'DO_REMOVE_INVITE_TENANT_FAILED',

  // DO_INVITE_TENANT ...
  doInviteTenant: response => ({
      type: tenantActions.DO_INVITE_TENANT,
      payload: response
  }),
  doInviteTenantSucceeded: response => ({
      type: tenantActions.DO_INVITE_TENANT_SUCCEEDED,
      payload: response
  }),
  doInviteTenantFailed: response => ({
      type: tenantActions.DO_INVITE_TENANT_FAILED,
      payload: response
  }),
  doInviteTenantReset: response => ({
    type: tenantActions.DO_INVITE_TENANT_RESET,
    payload: response
  }),

  // DO_ADD_CURRENT_TENANT ...
  doAddCurrentTenant: response => ({
    type: tenantActions.DO_ADD_CURRENT_TENANT,
    payload: response
  }),
  doAddCurrentTenantSucceeded: response => ({
    type: tenantActions.DO_ADD_CURRENT_TENANT_SUCCEEDED,
    payload: response
  }),
  doAddCurrentTenantFailed: response => ({
    type: tenantActions.DO_ADD_CURRENT_TENANT_FAILED,
    payload: response
  }),
  doAddCurrentTenantReset: response => ({
    type: tenantActions.DO_ADD_CURRENT_TENANT_RESET,
    payload: response
  }),

  // DO_LIST_CURRENT_TENANTS && DO_LIST_REFERENCE_TENANTS
  doListTenants: type => ({
    type: type === 'invite' ? tenantActions.DO_LIST_CURRENT_TENANTS : tenantActions.DO_LIST_REFERENCE_TENANTS,
    payload: type
  }),

  // DO_LIST_CURRENT_TENANTS ...
  // doListTenants: type => ({
  //   type: type === 'invite' ? tenantActions.DO_LIST_CURRENT_TENANTS : tenantActions.DO_LIST_REFERENCE_TENANTS,
  //   payload: type
  // }),
  doListCurrentTenantsSucceeded: response => ({
    type: tenantActions.DO_LIST_CURRENT_TENANTS_SCCEEDED,
    payload: response
  }),
  doListCurrentTenantsFailed: response => ({
    type: tenantActions.DO_LIST_CURRENT_TENANTS_FAILED,
    payload: response
  }),

  // DO_LIST_REFERENCE_TENANTS ...
  // doListReferenceTenants: response => ({
  //   type: tenantActions.DO_LIST_REFERENCE_TENANTS,
  //   payload: response
  // }),
  doListReferenceTenantsSucceeded: response => ({
    type: tenantActions.DO_LIST_REFERENCE_TENANTS_SCCEEDED,
    payload: response
  }),
  doListReferenceTenantsFailed: response => ({
    type: tenantActions.DO_LIST_REFERENCE_TENANTS_FAILED,
    payload: response
  }),

  // DO_SHOW_NEW_REFERENCE_FORM && DO_HIDE_NEW_REFERENCE_FORM
  doToggleNewReferenceForm: visible => ({
    type: visible
      ? tenantActions.DO_SHOW_NEW_REFERENCE_FORM
      : tenantActions.DO_HIDE_NEW_REFERENCE_FORM
  }),

  // DO_SHOW_NEW_REFERENCE_FORM && DO_HIDE_NEW_REFERENCE_FORM
  doToggleNewCurrentForm: visible => ({
    type: visible
      ? tenantActions.DO_SHOW_NEW_CURRENT_FORM
      : tenantActions.DO_HIDE_NEW_CURRENT_FORM
  }),

  doGetTenantRequestReference: response => ({
    type: tenantActions.DO_GET_TENANT_REQUEST_REFERENCE,
    payload: response
  }),

  doUpdateTenantRequestReference: response => ({
    type: tenantActions.DO_UPDATE_TENANT_REQUEST_REFERENCE,
    payload: response
  }),

  // DO_GET_RENT_VERIFY_DETAILS
  doGetRentVerifyDetails: hash => ({
    type: tenantActions.DO_GET_RENT_VERIFY_DETAILS,
    payload: hash
  }),
  doGetRentVerifyDetailsSuccess: response => ({
    type: tenantActions.DO_GET_RENT_VERIFY_DETAILS_SUCCESS,
    payload: response
  }),
  doGetRentVerifyDetailsFailed: response => ({
    type: tenantActions.DO_GET_RENT_VERIFY_DETAILS_FAILED,
    payload: response
  }),

  // DO_VERIFY_PAYMENT
  doVerifyPayment: payload => ({
    type: tenantActions.DO_VERIFY_PAYMENT,
    payload
  }),
  doVerifyPaymentSuccess: response => ({
    type: tenantActions.DO_VERIFY_PAYMENT_SUCCESS,
    payload: response
  }),
  doVerifyPaymentFailed: response => ({
    type: tenantActions.DO_VERIFY_PAYMENT_FAILED,
    payload: response
  }),

  // DO_DECLINE_PAYMENT
  doDeclinePayment: payload => ({
    type: tenantActions.DO_DECLINE_PAYMENT,
    payload
  }),
  doDeclinePaymentSuccess: response => ({
    type: tenantActions.DO_DECLINE_PAYMENT_SUCCESS,
    payload: response
  }),
  doDeclinePaymentFailed: response => ({
    type: tenantActions.DO_DECLINE_PAYMENT_FAILED,
    payload: response
  }),

  // DO_GET_TENANT_REFERENCE
  doGetTenantReference: hash => ({
    type: tenantActions.DO_GET_TENANT_REFERENCE,
    payload: hash
  }),
  doGetTenantReferenceSuccess: response => ({
    type: tenantActions.DO_GET_TENANT_REFERENCE_SUCCEEDED,
    payload: response
  }),
  doGetTenantReferenceFailed: response => ({
    type: tenantActions.DO_GET_TENANT_REFERENCE_FAILED,
    payload: response
  }),

  // DO_GET_OUTSTANDING_REFERENCE_REQUESTS
  doGetOutstandingReferenceRequests: () => ({
    type: tenantActions.DO_GET_OUTSTANDING_REFERENCE_REQUESTS
  }),
  doGetOutstandingReferenceRequestsSuccess: response => ({
    type: tenantActions.DO_GET_OUTSTANDING_REFERENCE_REQUESTS_SUCCESS,
    payload: response
  }),
  doGetOutstandingReferenceRequestsFailed: response => ({
    type: tenantActions.DO_GET_OUTSTANDING_REFERENCE_REQUESTS_FAILED,
    payload: response
  }),

  // DO_REMOVE_TENANT_REFERENCE
  doRemoveTenantReference: hash => ({
    type: tenantActions.DO_REMOVE_REFERENCE_TENANT,
    payload: hash,
  }),
  doRemoveTenantReferenceReset: () => ({
    type: tenantActions.DO_REMOVE_REFERENCE_TENANT_RESET,
  }),
  doRemoveTenantReferenceFailed: response => ({
    type: tenantActions.DO_REMOVE_REFERENCE_TENANT_FAILED,
    payload: response,
  }),

  // DO_REMOVE_TENANT_INVITE
  doRemoveTenantInvite: hash => ({
    type: tenantActions.DO_REMOVE_INVITE_TENANT,
    payload: hash,
  }),
  doRemoveTenantInviteReset: () => ({
    type: tenantActions.DO_REMOVE_INVITE_TENANT_RESET,
  }),
  doRemoveTenantInviteFailed: response => ({
    type: tenantActions.DO_REMOVE_INVITE_TENANT_FAILED,
    payload: response,
  }),
};
export default tenantActions;



// WEBPACK FOOTER //
// ./src/redux/tenants/actions.js